import { ContainerModule } from 'inversify';
import { QuizSessionService, QuizSessionServiceSymbol } from './quiz-session-service'

export const quizSessionServiceModule = new ContainerModule((bind) => {
  bind(QuizSessionServiceSymbol).to(QuizSessionService).inSingletonScope();
});
